/* eslint-disable jsx-a11y/accessible-emoji, no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated. Edit DropdownButton.view to change it. More info: https://github.com/viewstools/docs/blob/master/UseViews/README.md#viewjs-is-auto-generated-and-shouldnt-be-edited
import "DesignSystem/Fonts/WonderUnitSans-300.js"
import React from 'react'
import useIsHovered from 'Logic/useIsHovered.js'
import { css } from "emotion"

let styles = {}
styles.Vertical = css({label: 'Vertical',
  borderBottomLeftRadius: 4,
borderBottomRightRadius: 4,
borderStyle: "solid",
borderTopLeftRadius: 4,
borderTopRightRadius: 4,
overflowX: "hidden",
userSelect: "none",
"&:focus:enabled": {
backgroundColor: "white",
borderColor: "#00a2ff"
},
  
transition: 'background-color 150ms linear, border-color 150ms linear',
willChange: 'background-color, border-color',
  alignItems: 'var(--alignItems)',
backgroundColor: 'var(--backgroundColor)',
borderColor: 'var(--borderColor)',
borderWidth: 'var(--borderWidth)',
height: 'var(--height)',
justifyContent: 'var(--justifyContent)',
minWidth: 'var(--minWidth)',
width: 'var(--width)'})
styles.Text = css({label: 'Text',
  fontSize: 14,
color: "#161616",
fontFamily: "WonderUnitSans",
paddingBottom: 5,
fontWeight: 300,
lineHeight: 1.2,
textOverflow: "ellipsis",
whiteSpace: "nowrap",
overflowX: "hidden",
  paddingLeft: 'var(--paddingLeft)',
paddingRight: 'var(--paddingRight)',
paddingTop: 'var(--paddingTop)',
maxWidth: 'var(--maxWidth)',
width: 'var(--width)'})

export default function DropdownButton({
  children,
  'data-testid': dataTestid,
  'data-view-path': dataViewPath,
  alignItems= "flex-start",
backgroundColor= "#ffffff",
disabled,
height= "auto",
minWidth= 200,
valueWidth= 200,
onClick,
isInvalid,
text= "Select",
maxWidth,
isMultiChoice
}) {
    
    let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({})
    
    
    
    

  return (<React.Fragment
>
<button
 data-testid="DropdownButton.Vertical"
 data-view-path={dataViewPath}
 disabled={disabled}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--alignItems': alignItems,'--height': typeof height === 'number' ? `${height}px` : height,'--minWidth': typeof minWidth === 'number' ? `${minWidth}px` : minWidth,'--width': typeof valueWidth === 'number' ? `${valueWidth}px` : valueWidth,'--backgroundColor': disabled ? "transparent" : backgroundColor,'--borderColor': disabled ? "#ffffff" : isInvalid ? "rgba(224,51,51, 0.75)" : "#f2f2f2",'--justifyContent': disabled ? "flex-start" : "center",'--borderWidth': disabled ? "0px" : "2px"}}
 className={`views-block ${styles.Vertical}`}
>
<span
 data-testid="DropdownButton.Text"
 data-view-path={dataViewPath}
 style={{'--maxWidth': typeof maxWidth === 'number' ? `${maxWidth}px` : maxWidth,'--width': typeof valueWidth === 'number' ? `${valueWidth}px` : valueWidth,'--paddingRight': isMultiChoice ? "35px" : "8px",'--paddingTop': disabled ? "1px" : "5px",'--paddingLeft': disabled ? "0px" : "8px"}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}